<header class="ai-chat-header">
  <ng-container *ngIf="isExpanded; else panelCollapse">
    <button
      type="button"
      class="ai-header-close"
      aria-label="Close Octy assistant"
      (click)="collapseRequested.emit()"
    >
      <span></span>
      <span></span>
    </button>
  </ng-container>

  <ng-template #panelCollapse>
    <button
      type="button"
      class="ai-header-collapse"
      aria-label="Collapse assistant"
      (click)="collapseRequested.emit()"
    >
      <img src="/assets/media/eva/right-close.png" alt="" />
    </button>
  </ng-template>

  <!-- Greeting — visible only once a conversation is active -->
  <div class="ai-header-greeting" *ngIf="hasConversation">
    <img src="/assets/media/eva/eva-mini.png" alt="Octy" class="ai-header-octy" aria-hidden="true" />
    <div class="ai-header-greeting-copy">
      <span class="ai-header-greeting-label">{{ greeting }}</span>
      <span class="ai-header-greeting-sub">
        <span class="ai-header-greeting-dot"></span>
        {{ activeAgentName }}
      </span>
    </div>
  </div>

  <div class="ai-header-actions">
    <button
      type="button"
      class="ai-header-action-button"
      [attr.aria-label]="isExpanded ? 'Restore assistant sidebar' : 'Expand assistant full screen'"
      (click)="expandRequested.emit()"
    >
      <ng-container *ngIf="isExpanded; else maximizeIcon">
        <span class="ai-header-restore-icon" aria-hidden="true">
          <span></span>
          <span></span>
        </span>
      </ng-container>
      <ng-template #maximizeIcon>
        <i class="ki-filled ki-maximize"></i>
      </ng-template>
    </button>
    <button
      type="button"
      class="ai-header-action-button"
      aria-label="Assistant options"
      [attr.aria-expanded]="menuOpen"
      (click)="toggleMenu($event)"
    >
      <i class="ki-filled ki-dots-horizontal"></i>
    </button>

    <div class="ai-header-menu-backdrop" *ngIf="menuOpen" (click)="closeMenu()"></div>
    <div class="ai-header-menu" *ngIf="menuOpen">

      <!-- User profile block -->
      <div class="ai-header-menu-profile">
        <span class="ai-header-menu-avatar">{{ initials }}</span>
        <div class="ai-header-menu-user-info">
          <span class="ai-header-menu-user-name">{{ profile?.name }}</span>
          <span class="ai-header-menu-user-email">{{ profile?.email }}</span>
        </div>
      </div>

      <div class="ai-header-menu-divider"></div>

      <!-- Actions -->
      <button type="button" class="ai-header-menu-item" (click)="triggerMenuAction('new')">
        <i class="ki-filled ki-add-files"></i>
        <span>Start New</span>
      </button>
      <button type="button" class="ai-header-menu-item" (click)="triggerMenuAction('history')">
        <i class="ki-filled ki-time"></i>
        <span>History</span>
      </button>
      <button type="button" class="ai-header-menu-item" (click)="triggerMenuAction('settings')">
        <i class="ki-filled ki-setting-2"></i>
        <span>Settings</span>
      </button>

      <div class="ai-header-menu-divider"></div>

      <!-- Logout -->
      <button type="button" class="ai-header-menu-item ai-header-menu-item--logout" (click)="logout()">
        <i class="ki-filled ki-exit-right"></i>
        <span>Log out</span>
      </button>

    </div>
  </div>
</header>
